import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  groupActionDeleteDiv: {
    color: '#f74872',
    fontSize: 13,
    '& .MuiListItemIcon-root': {
      minWidth: 28,
    },
    '& span': {
      color: '#f74872',
    },
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  morevertIcon: {
    color: theme.palette.grey.morevertIcon,
  },
  tableContent: {
    position: 'relative',
    '& .rt-tbody .rt-tr:not(.-padRow):hover .fixBackground': {
      background: '#ececec',
    },
  },
  tableWithFilters: {
    '& .rt-tbody': {
      marginTop: 1,
    },
    '& .filter': {
      width: 120,
      '& .material-icons': {
        fontSize: '2.4rem !important',
      },
      '& .MuiInputBase-adornedEnd': {
        padding: '8px 0',
      },
      '& .MuiInputBase-inputAdornedEnd': {
        color: '#a8a8a8',
        fontSize: '12px !important',
      },
      '& .MuiFormHelperText-root': {
        fontSize: 10,
        marginTop: 4,
        color: '#a8a8a8',
      },
      '& .MuiInput-underline:before': {
        borderColor: '#a8a8a8',
      },
    },
  },
  tableContentEmpty: {
    padding: 50,
  },
  createBtn: {
    float: 'right',
    marginTop: 25,
    backgroundColor: '#0073b1',
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
  },
  emptyTextOne: {
    color: '#a8a8a8',
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 15,
  },
  createBtnSecond: {
    marginTop: 24,
    fontSize: 12,
    backgroundColor: '#0073b1',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
    '& span': {
      marginLeft: 8,
    },
  },
  emptyIconOne: {
    color: '#a8a8a8',
    '& i': {
      fontSize: 156,
    },
  },
  gridEmpty: {
    minHeight: '-webkit-fill-available',
  },
  paper: {
    marginTop: 20,
    padding: 15,
  },
  cardWrapp: {},
  addSubGroupBtn: {
    color: '#fff',
    right: -17,
    bottom: 0,
    margin: 'auto',
    top: 0,
    position: 'absolute',
    zIndex: 99,
  },
  languageCard: {
    marginBottom: 4,
    minHeight: 100,
  },
  card: {
    position: 'relative',
    minWidth: 275,
    marginBottom: 15,
    overflowY: 'auto',
  },
  cardTitle: {
    marginLeft: 28,
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 25,
  },
  card_info: {
    overflow: 'inherit',
  },
  subgroups: {
    fontSize: 14,
  },
  card_one_actions: {
    alignItems: 'start',
    '& button': {
      justifyContent: 'start',
    },
  },
  card_one_info: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  dialog_one_title: {
    fontWeight: 'bold',
  },
  dialog_one_title_wrapp: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  dialogActionBtnsStyleOne: {
    marginTop: 15,
  },
  icons_one: {
    fontSize: 16,
    marginRight: 3,
  },
  subgroup_item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomRightRadius: '50px',
    borderTopRightRadius: '50px',
    padding: '9px 28px',
    paddingRight: '10px',
    background: 'transparent',
    color: 'black',
    marginRight: 20,
    marginBottom: 0,
    fontSize: 14,
    [useBreakpoints(theme).lessThan.lg]: {
      '&.active .subgroup_item_action_btn': {
        display: 'inline-block',
      },
    },
  },
  subgroup_item_add: {
    color: theme.palette.secondary.main,
    marginTop: 8,
  },
  subgroup_item_hover: {
    '&:hover': {
      background: theme.palette.grey.light,
    },
    '&.active': {
      background: theme.palette.secondary.main,
      color: 'white',
    },
  },
  subgroup_item_title: {
    flex: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  subgroup_item_action_btn: {
    display: 'none',
    height: 16,
    '& span': {
      cursor: 'pointer',
    },
  },
  subgroup_item_icon: {
    fontSize: '1.6rem',
  },
  subgroup_item_text: {
    marginLeft: '8px',
    marginRight: '6px',
    lineHeight: '14px',
  },
  input_new_group_title: {
    padding: '16px 24px 0 24px',
    fontSize: 16,
  },
  detailsTable: {
    margin: '0 0 0 22px',
    backgroundColor: '#fff',
    '& .ReactTable': {
      border: 0,
    },
    '@media(max-width:600px)': {
      margin: 0,
    },
  },
  dialog_root: {
    overflow: 'visible',
  },
  snackbar_success: {
    backgroundColor: '#008000',
    borderRadius: '50px',
  },
  table_detail: {
    width: '100%',
    textAlign: 'left !important',
  },
  tableNoData: {
    position: 'absolute',
    display: 'flex',
    top: '2px',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      marginTop: 20,
      marginBottom: 12,
    },
  },
  emptyContainer: {
    borderColor: 'rgba(0,0,0,0.05)',
    paddingLeft: 40,
    paddingRight: 40,
  },
  toolbar_group_page: {
    backgroundColor: '#fff',
    justifyContent: 'space-between',
  },
  tableItemName: {
    fontWeight: 'bold',
    fontFamily: `Roboto,"Helvetica",Arial,sans-serif !important`,
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid black',
    borderRadius: '4px',
    padding: '4px',
    paddingLeft: '6px',
  },
  searchBoxInput: {
    background: 'transparent',
  },
  mediumIcon: {
    fontSize: '3rem',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    width: '100%',
    paddingLeft: '2.4rem',
  },
  pageInfos: {
    display: 'flex',
    alignItems: 'center',
  },
  spaceRight: {
    marginRight: 16,
    marginTop: 5,
  },
  backToAll: {
    color: theme.palette.secondary.main,
    display: 'inline-flex',
    alignItems: 'center',
  },
  backToAllText: {
    lineHeight: '1.4',
  },
  groupButton: {
    textTransform: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    fontColor: 'rgba(0, 0, 0, 0.54)',
  },
  firstGroupButton: {
    paddingLeft: 0,
  },
  buttonIcon: {
    fontSize: '2.4rem',
    marginRight: 4,
  },
  deleteBtn: {
    backgroundColor: '#f74872',
    '&:hover': {
      backgroundColor: '#f74872',
      borderColor: '#f74872',
    },
    '&:focus': {},
  },
  groupActionBtns: {
    padding: '8px 30px',
  },
  actionBtnsQWrapp: {
    padding: '8px 25px',
  },
  actionBtn: {
    backgroundColor: '#0073b1',
    '&:hover': {
      backgroundColor: '#0073b1',
      borderColor: '#0073b1',
    },
    '&:focus': {},
  },
  groupDialogTwo: {
    '& .MuiPaper-root': {
      // padding: '24px 15px 8px 15px',
    },
  },
  groupDialogStyleOne: {
    '& .MuiPaper-root': {
      maxWidth: 422,
    },
  },
  groupDialogStylTwo: {
    '& .MuiPaper-root': {
      minWidth: 410,
    },
  },
  subgroupCardContent: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 15,
    paddingBottom: 10,
  },
  group_info: {
    marginTop: 16,
    paddingTop: 32,
    paddingBottom: 12,
  },
  groupInfoTitle: {
    marginBottom: 24,
    fontSize: 24,
    color: '#0f3040',
    fontWeight: 'bold',
  },
  group_info_counts: {
    marginBottom: 10,
  },
  renameActionBtns: {
    paddingRight: 24,
  },
  langItem: {
    color: '#0073b1',
    fontSize: 16,
    marginTop: 5,
  },
  subGroupTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingLeft: 24,
    paddingBottom: 15,
    boxShadow: '0px 15px 12px -14px rgba(0, 0, 0, 0.05)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
  },
  detachIcon: {
    cursor: 'pointer',
    color: 'red',
  },
  deleteTabBtn: {
    color: '#f74872',
    '& span': {
      color: '#f74872',
    },
  },
  exportTabBtn: {
    color: '#0073b1',
    '& span': {
      color: '#0073b1',
    },
  },
  pageHeaderRightBar: {
    display: 'flex',
    flexDirection: 'initial',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2.4rem',
  },
  groupsLanguagesTitle: {
    fontSize: 16,
    color: '#0f3040',
    fontWeight: 'bold',
  },
  noGroupsMsg: {
    textAlign: 'center',
    fontSize: 24,
    marginTop: 50,
    fontWeight: 'bold',
  },
  tableNoSubscribers: {
    textAlign: 'center',
    padding: 45,
    color: '#0f3040',
  },
  link: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none !important',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none !important',
    },
  },
  normalText: {
    color: theme.palette.textHighlight.main,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  deleteMenu: {
    color: theme.palette.negative.main,
  },
  groupName: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#404040',
  },
  fixBackgroundLight: {
    background: '#fff',
    zIndex: 2,
  },
  tablePanel: {
    marginBottom: 16,
  },
  linkToWithoutSubscribers: {
    fontSize: 14,
    color: '#0073b1 !important',
    textDecoration: 'none !important',
  },
  groupBtn: {
    [useBreakpoints(theme).lessThan.lg]: {
      padding: '18px 42px',
      lineHeight: 1.12,
    },
  },
  restrictedText: {
    color: theme.palette.primary.subtitle,
  },
  groupTable: {
    '& .rt-thead': {
      position: 'sticky',
      left: 0,
      zIndex: 0,
    },
    '& .rt-tbody .rt-tr:not(.-padRow):hover .fixBackgroundLight': {
      background: 'rgb(242, 242, 242)',
    },
  },
  addSubscriberTable: {
    marginTop: 16,
    '& .rt-tbody': {
      overflow: 'auto !important',
      maxHeight: 270,
    },
  },
  addSubscriberHint: {
    fontSize: 14,
    color: '#a8a8a8',
    marginTop: 16,
    marginBottom: 16,
  },
  addSubscriberSearchNoData: {
    width: '100%',
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addSubscriberNoData: {
    color: '#404040',
    marginTop: 16,
    marginBottom: 16,
  },
  groupDialogTitleWrap: {
    wordBreak: 'break-all',
  },
}))
